<template>
  <a-layout id="components-layout-demo-top">
    <!-- 头部文件 -->
    <a-layout-header>
      <div class="logo" @click="jump('/')">
        <img :src="logo_big" alt="" />
      </div>
      <div class="vd-layout-header-right">
        <a-dropdown
          placement="bottomRight"
          :overlayStyle="{ 'min-width': '150px' }"
        >
          <div>
            <a-avatar
              style="margin-right:10px"
              size="small"
              icon="user"
              :src="defaultAvatar"
            />
            <span>{{ userInfo.nickname }} ({{ userInfo.username }})</span>
          </div>
          <a-menu slot="overlay">
            <a-menu-item
              key="/admin_center/base"
              @click="jump('/admin_center/base')"
            >
              <a-icon type="user" />
              <span>个人中心</span>
            </a-menu-item>
            <a-menu-item
              key="/admin_setting/base"
              @click="jump('/admin_setting/base')"
            >
              <a-icon type="setting" />
              <span>个人设置</span>
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item key="3" @click="logout()">
              <a-icon type="logout" />
              <span>退出登陆</span>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </a-layout-header>
    <!-- 主体内容 -->
    <a-layout-content>
      <a-row :gutter="16" style="height: calc(100vh - 64px);width:100%">
        <a-col class="gutter-row" :span="8">
          <!-- 侧边栏 -->
          <div class="element-show-list">
            <div class="element-content">
              <!-- 后台获取 类型 并且展示-->
              <div class="toolbar-editor">
                <template v-if="cateTree.length">
                  <template v-for="(item, index) in cateTree">
                    <a-dropdown :key="index">
                      <a-menu slot="overlay">
                        <a-menu-item :key="item.id" @click="selectType(item)">
                          {{ item.name }}
                        </a-menu-item>
                        <template v-if="item.children.length > 0">
                          <template v-for="type in item.children">
                            <!-- 数据 -->
                            <a-menu-item
                              :key="type.id"
                              @click="selectType(type)"
                            >
                              {{ type.name }}
                            </a-menu-item>
                          </template>
                        </template>
                      </a-menu>
                      <a-button
                        size="small"
                        style="margin-left: 8px;margin-top: 8px"
                      >
                        <template
                          v-if="
                            nowSelectType !== undefined &&
                              nowSelectType.pid === item.id
                          "
                        >
                          {{ nowSelectType.name }}
                        </template>
                        <template v-else>
                          {{ item.name }}
                        </template>
                        <a-icon type="down" />
                      </a-button>
                    </a-dropdown>
                  </template>
                </template>
              </div>
              <!-- 搜索 -->
              <div class="search-bar">
                <div class="search-input">
                  <input
                    v-model="searchInput"
                    placeholder="输入关键字"
                    type="text"
                    autocomplete="off"
                  />
                  <span @click="onSearch"><a-icon type="search"/></span>
                </div>
                <div class="search-span">
                  <a-button-group size="small">
                    <a-button
                      :type="searchType === 'week' ? 'primary' : ''"
                      @click="changeDate('week')"
                      >最新</a-button
                    >
                    <a-button
                      :type="searchType === 'month' ? 'primary' : ''"
                      @click="changeDate('month')"
                      >最近</a-button
                    >
                    <a-button
                      :type="searchType === 'favour' ? 'primary' : ''"
                      @click="changeDate('favour')"
                      >收藏</a-button
                    >
                  </a-button-group>
                </div>
                <a-button size="small" type="link" @click="resetSearchItem">
                  重置</a-button
                >
                <!-- <div class="search-checkbox">-->
                <!--    <label for="darkModel" style="">夜间模式 </label>-->
                <!-- <input style="margin: 0;" id="darkModel" type="checkbox" value="0">-->
                <!-- </div>-->
              </div>
              <!-- 素材内容 -->
              <div class="data-main" id="ListingTag" @wheel="scrollListing">
                <ul style="margin: 0;padding: 0">
                  <template v-for="item in dataList">
                    <li class="item-option" :key="item.id">
                      <div class="item-favour">
                        <template v-if="item.is_favour">
                          <a-icon
                            @click="materialFavour(item)"
                            type="heart"
                            :style="{ fontSize: '20px', color: '#eb2f96' }"
                            theme="filled"
                          />
                        </template>
                        <template v-else>
                          <a-icon
                            @click="materialFavour(item)"
                            type="heart"
                            :style="{ fontSize: '20px' }"
                            theme="twoTone"
                            two-tone-color="#eb2f96"
                          />
                        </template>
                      </div>
                      <div
                        @click="append_to_editor(item.content, item.id)"
                        v-html="item.content"
                      ></div>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </div>
        </a-col>
        <a-col class="gutter-row" :span="12">
          <div class="gutter-box" style="display: flex">
            <u-editor v-model="msg" :config="myConfig" @ready="ready">
            </u-editor>
            <div class="editor-tool-button">
              <button class="clipboard-copy" @click="clipboard">
                复制到微信
              </button>
              <button @click="preview">预览</button>
              <!--              <button @click="mobile_preview">手机预览</button>-->
              <button @click="cleanEditor">清空</button>
              <button
                @click="
                  () => {
                    this.draftVisible = !this.draftVisible;
                  }
                "
              >
                新建草稿
              </button>
              <button @click="saveDraft">保存到草稿箱</button>
              <button @click="getDraft">查看草稿</button>
              <!-- <button id="createPic">生成长图</button> -->
            </div>
          </div>
        </a-col>
      </a-row>
      <!-- 颜色选择器 -->
      <div
        class="colorpicker"
        :style="{
          top: pop_top + 170 + 'px',
          left: pop_left - 280 + 'px',
          display: colorPickerShow ? 'block' : 'none',
        }"
      >
        <div
          title="关闭颜色选择器"
          @click="show_color_picker"
          style="position: absolute;left: 245px;background-color: #d76d7c;border-radius: 50%;width:18px;height: 18px;display: flex;justify-content: center;align-items: center;"
        >
          <a-icon style="color: white" type="close" />
        </div>
        <chrome-picker v-model="color_picker" />
      </div>
      <!-- 工具框体 -->
      <div
        id="_pop"
        :style="{
          position: 'absolute',
          display: 'none',
          top: pop_top + 'px',
          left: pop_left + 'px',
          'z-index': 9999,
        }"
        @mousedown="_moveOnDraw($event)"
      >
        <section class="zg-poptools" style="min-width: 350px;max-width: 350px;">
          <section class="edui-toolbar">
            <div class="tool-title " style="color:#ff0000;border-color:#ff0000">
              全局样式
              <span id="style-data-id" style="color: white; font-size: 10px;"
                >样式ID: {{ pop_id }}</span
              >
            </div>
            <section>
              <span class="copy" @click="copy_editor" title="复制样式代码"
                >复制</span
              >
              <span
                class="cut"
                @click="cut_editor"
                title="复制样式后，删除对应内容"
                >剪切</span
              >
              <span
                class="select"
                @click="select_editor"
                title="选中区域中文本后，可以将样式秒刷更换为别的样式"
                >选中</span
              >
              <span class="remove" @click="remove_editor" title="删除本样式"
                >删除</span
              >
              <span class="moveup" @click="move_up_editor">上移</span>
              <span class="movedown" @click="move_down_editor">下移</span>
              <span
                class="_zgconvertImage"
                @click="cover_to_img_editor"
                title="转为图片"
                >转为图片</span
              >
            </section>
            <section>
              <span
                class="_blank"
                @click="blank_editor"
                title="样式之后插入空行"
                >后空行</span
              >
              <span
                class="_preblank"
                @click="pre_blank_editor"
                title="样式之前插入空行"
                >前空行</span
              >
              <span
                class="_colors"
                @click="colors"
                title="将换色与宽度调整应用到其它相同样式"
                >传递</span
              >
            </section>
            <section>
              <span
                class="_para"
                @click="show_params_editor"
                title="设置段落字体、缩进、行高、段落间距等。"
                >段落</span
              >
              <div
                class="para-popup common-popup popup edui-toolbar"
                :style="{ display: showParams ? 'block' : 'none' }"
                style="width: 300px; top: 0px; left: -300px; "
              >
                <p style="color:white" class="edui-default">
                  默认为空,且空项不会被应用到样式上
                </p>

                <div class="input-container inline-container">
                  <span>行高:</span>
                  <input v-model="line_height" type="number" data-unit="em" />em
                  <span>字号:</span>
                  <input v-model="fontsize" type="number" data-unit="px" />px
                </div>
                <div class="input-container inline-container">
                  <span>字体:</span>
                  <input v-model="font_family" type="number" />
                  <span style="margin-left: 22px;">字间距:</span>
                  <input v-model="letter_spacing" type="number" />px
                </div>
                <div class="input-container inline-container">
                  <span>颜色:</span>
                  <input
                    id="color-picker"
                    v-model="color"
                    @click="show_color_picker"
                    type="text"
                    autocomplete="off"
                  />
                  <span style="margin-left: 22px;">首行缩进:</span>
                  <input v-model="text_indent" type="number" />em
                </div>
                <div class="input-container inline-container">
                  <span>段前距:</span>
                  <input
                    name="margin-top"
                    v-model="before_space"
                    type="number"
                  />px
                  <span style="margin-left: 8px;">段后距:</span>
                  <input
                    name="margin-bottom"
                    v-model="after_space"
                    type="number"
                  />px
                </div>
                <button
                  class="para-cancel vd-bottom-editor"
                  @click="show_params_editor"
                >
                  取消
                </button>
                <button class="para-all vd-bottom-editor" @click="params_all">
                  应用到全文
                </button>
                <button
                  class="para-selection vd-bottom-editor"
                  @click="params_this"
                >
                  应用到本样式
                </button>
              </div>
              <span class="offset" @click="show_offset_editor" title="位置偏移"
                >偏移</span
              >
              <div
                class="offset-popup common-popup popup edui-toolbar"
                :style="{ display: showOffset ? 'block' : 'none' }"
                style="width: 170px; top: 100px; left: 15px;"
              >
                <div class="input-container inline-container ">
                  <span>左右偏移</span>
                  <input
                    v-model="offsetX"
                    @change="offset_x"
                    type="number"
                  />像素
                </div>
                <div class="input-container inline-container ">
                  <span>上下偏移</span>
                  <input
                    v-model="offsetY"
                    @change="offset_y"
                    type="number"
                  />像素
                </div>
              </div>
              <span class="replace" @click="replace_editor" title="替换文字"
                >替换文字</span
              >
              <div
                class="replace-popup common-popup popup edui-toolbar"
                :style="{ display: showReplace ? 'block' : 'none' }"
                style="width: 150px; top: 100px; left: 125px;"
              >
                <div class="input-container inline-container">
                  <input
                    class="replace-src-text"
                    v-model="replaceSrcText"
                    type="text"
                    placeholder="待匹配内容"
                    style="width: 100%;margin:0 0"
                  />
                </div>

                <div class="input-container inline-container">
                  <input
                    class="replace-dest-text"
                    v-model="replaceDestText"
                    type="text"
                    placeholder="替换内容"
                    style="width: 100%;margin:0 0"
                  />
                </div>

                <div>
                  <button
                    class="replace-confirm"
                    title="替换内容确认"
                    @click="replace"
                  >
                    替换
                  </button>
                </div>
              </div>
              <span class="clean" @click="clean_editor" title="清除格式"
                >清除格式</span
              >
              <div class="input-container inline-container layout">
                <span>宽度比</span>
                <div
                  class="layout-slider slider n-slider"
                  style="height: 20px; width: 185px; margin-right: 10px;"
                >
                  <div
                    @mousedown="_moveLayout($event)"
                    class="marker"
                    :style="{ left: (180 * layout_ratio) / 100 + 1 + 'px' }"
                  ></div>
                </div>
                <input
                  class="layout"
                  name="layout"
                  type="number"
                  v-model="layout_ratio"
                />%
              </div>
              <div class="input-container inline-container rotatez">
                <span>转角度</span>
                <div
                  class="rotatez-slider slider n-slider"
                  style="height: 20px; width: 185px; margin-right: 10px;"
                >
                  <div
                    @mousedown="_moveRotate($event)"
                    class="marker"
                    :style="{ left: angle_ratio / 2 + 90.5 + 'px' }"
                  ></div>
                </div>
                <input
                  class="rotatez"
                  name="rotatez"
                  type="number"
                  v-model="angle_ratio"
                />
              </div>
              <div class="input-container inline-container opacity">
                <span>透明度</span>
                <div
                  class="opacity-slider slider n-slider"
                  style="height: 20px; width: 185px; margin-right: 10px;"
                >
                  <div
                    @mousedown="_moveOpacity($event)"
                    class="marker"
                    :style="{ left: 180 * opacity + 1 + 'px' }"
                  ></div>
                </div>
                <input
                  class="opacity"
                  name="opacity"
                  type="number"
                  v-model="opacity"
                />
              </div>
            </section>
          </section>
          <div
            title="移动到合适的位置后锁定操作栏位置"
            @click="tran_lock"
            class="lock tool-btn"
            style="left: 290px;"
          >
            <template v-if="pop_move">
              <a-icon type="unlock" />
            </template>
            <template v-else>
              <a-icon type="lock" />
            </template>
          </div>
          <div
            title="关闭工具栏"
            @click="p_close"
            class="btn-close tool-btn"
            style="left: 315px;"
          >
            <a-icon type="close" />
          </div>
        </section>
      </div>

      <!-- 页面预览区域 -->
      <div
        class="preview-modal"
        :style="{ display: screenVisible ? 'flex' : 'none' }"
      >
        <!--5.5 寸以上-->
        <div
          class="screenPlus5"
          :style="{ display: nowScreen === 1 ? 'block' : 'none' }"
        >
          <div class="screenPlus5Content" v-html="screenContent"></div>
        </div>

        <div
          class="screen5"
          :style="{ display: nowScreen === 2 ? 'block' : 'none' }"
        >
          <div class="screen5Content" v-html="screenContent"></div>
        </div>

        <div
          class="screenDown5"
          :style="{ display: nowScreen === 3 ? 'block' : 'none' }"
        >
          <div class="screenDown5Content" v-html="screenContent"></div>
        </div>
        <img
          @click="closePreview"
          class="preview-modal-close"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAlCAYAAADFniADAAADJ0lEQVRYhc2Yy0tUcRTHP16NyEVlizJrYw+LCksiXGuFBAmtotoE9geEtumxEkqiBwQtI6qF9NgUJFmRM+2i9xgYPYiC0DKGpAJbiXHg+4vhcmfm/mbuqAcuwvj7nfO555zf75x7qrLZLJ6yAGjX0ww0AYv0/NLzAXgDpIEh4K+PCR+ojUAPsAfIACnguQAmBGNgdQLdJvAtwB3gPPA2KajlUtgGXASuAmNx30T7DwKH5bkjwLdCG4IiCvcrDF+ANUCfJxACOA2slh7Td6DQhnyeqpJ3dgN7Fa6kxMJ5CxiQ16bDeqM8ZUBXlBOtCQMhfa3Sfw2ojgN1Tq7uUAJXQiakvxG4UAxqH9CpsE1WCMjJpOx0KHf/S25ONci1tuh1hYFypQV4oL+jhDx1Frg0w0DIntk9435wnrKL8ZFyqdJhi5Ja4BOwAxhxnurRxTgbQMiu2e9GnjLKr8CmYjdthaVeZWhloPKR8QR6ArwClhZYYwdnGHgcU+d35Vd7oKI55OmE+Tot6TxgDfpfs9bGFeNoC7TxpSfULrl6QwSYA2qSpzo99BrHZoNaC7zzhBqXh8NgYSA7TT4N23vjqVH/U0o5cWCpHLCaMoBMfhqPnb5pFeFSZVkOGGUAOZm28P0GFpYBVS0POZkXVfljinH8CRS6uhKVrAjlkMuxlDzoK0uMx6A+AutLBEqFcqi9TLB1xhOoPd2aAFA24lT6ghnHcCD3b/eEGhRQJiKpx1UlHNiAh17jSAd6mxbVnrgyoVKzM88p+yGwFx7XTb04Uq51uazWoc8DLGk5rtbp0Jzup0YUxhOzAITspsUxJ3p0+w58mK9HH9On9Q3NBGZCzM5N2R119sKfWNeBe8BdxbmSUis7g7JLPijUr3/WZ0+p5aeYLAbuy053eG0UlHUNXWp3nyrmSYrpe6a87Yo7SzCZUpx7dVWcSiCctv+k9PVK/1TUwmKjoH61y426R45p3uQjtv6o9q+Svv5C+2tiKLdTafMku2BtdGM1zXppu1fcJM86RteXWfvhJnlWaqzI3nYXY5yXKXXmaYUzPPM0IAPLnXnahew38wT+AQo365amGschAAAAAElFTkSuQmCC"
        />
        <ul class="screen-ul">
          <li :class="nowScreen === 1 ? 'active' : ''" @click="switchScreen(1)">
            5.5寸以上
          </li>
          <li :class="nowScreen === 2 ? 'active' : ''" @click="switchScreen(2)">
            5.5寸屏幕
          </li>
          <li :class="nowScreen === 3 ? 'active' : ''" @click="switchScreen(3)">
            5.5寸以下
          </li>
        </ul>
      </div>
      <!-- 弹出框 -->
      <a-modal
        v-model="draftVisible"
        title="新建草稿"
        ok-text="确认"
        cancel-text="取消"
        @ok="draftAdd"
      >
        <div>
          编辑器当前内容将保存到新草稿当中:
        </div>
        <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-form-item label="草稿名称">
            <a-input v-model="nowDraft.name" class="vd-input-s" />
          </a-form-item>
        </a-form>
      </a-modal>
      <!-- 模版列表 -->
      <a-drawer
        :visible="drawVisible"
        title="我的草稿"
        placement="left"
        @close="drawClose"
        width="700px"
      >
        <a-table
          size="small"
          @change="pageChange"
          row-key="id"
          :pagination="draft_pagination"
          :data-source="draft_list"
          :scroll="{ x: 1000 }"
        >
          <a-table-column title="id" data-index="id" fixed="left" :width="50" />
          <a-table-column
            title="草稿名称"
            data-index="name"
            fixed="left"
            :width="75"
          />
          <a-table-column
            title="内容"
            align="center"
            data-index="content"
            :width="568"
          >
            <template slot-scope="text">
              <span v-html="text"></span>
            </template>
          </a-table-column>

          <a-table-column title="操作" fixed="right">
            <template slot-scope="text">
              <a-tag color="blue" @click="useDraft(text)">使用</a-tag>
              <a-tag color="red" @click="deleteDrafts(text.id)">删除</a-tag>
            </template>
          </a-table-column>
        </a-table>
      </a-drawer>
    </a-layout-content>
  </a-layout>
</template>
<script>
/* https://github.com/HaoChuan9421/vue-ueditor-wrap */
import VueEditorWrap from "vue-ueditor-wrap";
import logo_big from "@/assets/logo_big.png";
import defaultAvatar from "@/assets/default.jpg";
import store from "@/store";
import $ from "jquery";
import Clipboard from "clipboard";
import { Chrome } from "vue-color";
import { getEditorCate } from "@/api";
import {
  getMaterial,
  materialFavourApi,
  pointCount,
  materialDraft,
  getDraftList,
  deleteDraft,
  mobilePreview,
} from "@/api/editor";

const key = "loading";
export default {
  name: "index",
  components: {
    uEditor: VueEditorWrap,
    chromePicker: Chrome,
  },
  data() {
    let baseURL =
      process.env.NODE_ENV === "development"
        ? process.env.VUE_APP_DEVELOPMENT_PROXY
        : process.env.VUE_APP_PRODUCTION_URL;

    // console.log(baseURL + '/api/v1/upload')
    let screenHeight = window.innerHeight;
    let FrameHeight = screenHeight - 180;
    let FrameWidth = 500;
    return {
      colorPickerShow: false,
      color_picker: "#fff",
      logo_big,
      defaultAvatar,
      userInfo: {},
      openKeys: "",
      msg: undefined,
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: FrameHeight,
        // 初始容器宽度
        initialFrameWidth: FrameWidth,
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！部署在国外的服务器，如果无法访问，请自备梯子）
        serverUrl: baseURL + "/api/v1/upload",
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: "/UEditor/",
      },
      // 编辑器变量
      UEInstance: null,
      dialog_global: null,
      NowCursorSelection: null,
      is_ready: false,
      Range: null,
      NowSelect: null,
      pop_id: 0,
      pop_move: true,
      pop_show: false,
      pop_top: 500,
      pop_left: 800,
      d_start_top: 0,
      d_start_left: 0,
      startX: 0,
      startY: 0,
      // 全局样式变量
      layout_ratio: 100,
      angle_ratio: 0,
      opacity: 1,
      screenVisible: false,
      screenContent: undefined,
      nowScreen: 1,
      showParams: false,
      showOffset: false,
      showReplace: false,
      replaceSrcText: "",
      replaceDestText: "",
      offsetX: 0,
      offsetY: 0,
      // 段落变量
      line_height: 0, // 行高
      fontsize: 0, // 字号
      font_family: "", // 字体
      letter_spacing: 0, // 字间距
      color: "#000", // 字体颜色
      text_indent: 0, // 首行缩进
      before_space: 0, // 段前距
      after_space: 0, // 段后距
      /* 数据 - 用户 相关 */
      cateTree: [],
      nowSelectType: undefined,
      searchType: undefined,
      searchInput: "",
      dataList: [],
      favour: [],
      current: 1,
      loading: false,
      noData: false,
      draftVisible: false,
      add_draft: false,
      nowDraft: {
        id: 0,
        name: "",
        content: "",
      },
      drawVisible: false,
      draft_list: [],
      draft_pagination: {
        total: 0,
        current: 1,
        pageSize: 3,
      },
    };
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
    setInterval(() => {
      this.localSave();
      console.log("草稿保存成功");
    }, 50000);
  },
  mounted() {
    let draft = JSON.parse(localStorage.getItem("draft"));
    if (draft !== null && draft["id"] !== undefined && draft.id !== 0) {
      this.nowDraft = draft;
    }
    // 获取页面数据
    getEditorCate().then((res) => {
      if (res["code"] === 1) {
        this.cateTree = res["tree"];
        this.getData();
      } else {
        this.$message.error("数据加载异常,4s后再试");
        setTimeout(() => {
          this.getEditor();
        }, 4000);
      }
    });
  },
  methods: {
    localSave() {
      this.nowDraft.content = this.UEInstance.getContent();
      let draft = JSON.stringify(this.nowDraft);
      localStorage.setItem("draft", draft);
    },
    getData() {
      if (!this.loading) {
        this.loading = true;
        this.$message.loading({ content: "素材加载中...", key });

        let type_id =
          this.nowSelectType === undefined ? 0 : this.nowSelectType.id;
        let search_type = this.searchType === undefined ? "" : this.searchType;
        getMaterial({
          select_type: type_id,
          search_type: search_type,
          current: this.current,
          input_text: this.searchInput,
        }).then((res) => {
          this.loading = false;
          if (res["code"] === 1) {
            this.$message.success({ content: "加载完成", key, duration: 0.5 });
            this.dataList.push.apply(this.dataList, res["list"]);
          } else {
            this.noData = true;
            this.$message.warning({ content: "没有素材了", key });
          }
        });
      }
    },
    /* ----------------  素材相关接口 ------------------------*/
    // 切换素材类型
    selectType(item) {
      this.noData = false;
      this.current = 1;
      this.nowSelectType = item;
      this.dataList = [];
      this.noData = false;
      this.getData();
    },
    // 最近 最新 收藏
    changeDate(type) {
      if (this.searchType === undefined) {
        this.searchType = type;
      } else {
        if (type === this.searchType) {
          this.searchType = undefined;
        } else {
          this.searchType = type;
        }
      }
      this.current = 1;
      this.dataList = [];
      this.noData = false;
      this.getData();
    },
    // 搜索框
    onSearch() {
      console.log(this.searchInput);

      this.current = 1;
      this.dataList = [];
      this.noData = false;
      this.getData();
    },
    // 重置搜索条件
    resetSearchItem() {
      this.current = 1;
      this.dataList = [];
      this.noData = false;
      this.searchType = undefined;
      this.nowSelectType = undefined;
      this.searchInput = "";
      this.getData();
    },
    // 计算点击量
    addPointCount(id) {
      pointCount({
        material_id: id,
      }).then((res) => {
        if (res["code"] !== 1) {
          this.$message.warning(res["msg"]);
        }
      });
    },
    // 加入收藏列表
    materialFavour(item) {
      let type = item.is_favour ? "cancel" : "confirm";

      materialFavourApi({
        material_id: item.id,
        type: type,
      }).then((res) => {
        if (res["code"] === 1) {
          item.is_favour = !item.is_favour;
          this.$message.success({ content: res["msg"], key: "favour" });
        } else {
          this.$message.warning(res["msg"]);
        }
      });
    },
    //新建草稿
    draftAdd() {
      this.nowDraft.content = this.UEInstance.getContent();
      if (this.nowDraft.content === "") {
        this.$message.warning("编辑器内容为空!");
        return false;
      }
      if (!this.add_draft) {
        this.add_draft = true;
        materialDraft({
          id: 0,
          name: this.nowDraft.name,
          content: this.nowDraft.content,
        }).then((res) => {
          this.add_draft = false;
          if (res["code"] === 1) {
            this.draftVisible = false;
            this.nowDraft.id = res["draft"]["id"];
            localStorage.setItem("draft", JSON.stringify(this.nowDraft));
            this.$message.success(res["msg"]);
          } else {
            this.$message.warning(res["msg"]);
          }
        });
      } else {
        this.$message.warning("请勿重复操作!");
      }
    },
    // 保存草稿
    saveDraft() {
      if (this.nowDraft.id === 0) {
        // 新建
        this.draftVisible = true;
        this.$message.warning("请先新建草稿");
      } else {
        if (!this.add_draft) {
          this.add_draft = true;
          this.nowDraft.content = this.UEInstance.getContent();
          materialDraft(this.nowDraft).then((res) => {
            this.add_draft = false;
            if (res["code"] === 1) {
              this.draftVisible = false;
              this.nowDraft.id = res["draft"]["id"];
              localStorage.setItem("draft", JSON.stringify(this.nowDraft));
              this.$message.success(res["msg"]);
            } else {
              this.$message.warning(res["msg"]);
            }
          });
        } else {
          this.$message.warning("请勿重复操作!");
        }
      }
    },
    // 获取草稿
    getDraft() {
      this.drawVisible = true;
      getDraftList({
        current: this.draft_pagination.current,
      }).then((res) => {
        if (res["code"] === 1) {
          this.draft_list = res["list"];
          this.draft_pagination.total = res["total"];
        } else {
          this.$message.warning(res["msg"]);
        }
      });
    },
    // 使用草稿
    useDraft(record) {
      // 替换当前
      this.nowDraft.id = record.id;
      this.nowDraft.name = record.name;
      this.nowDraft.content = record.content;
      this.UEInstance.setContent(record.content);
      // 保存到缓存
      this.localSave();
    },
    // 删除当前草稿
    deleteDrafts(id) {
      deleteDraft({ id: id }).then((res) => {
        if (res["code"] === 1) {
          this.$message.success(res["msg"]);
          this.draft_pagination.current = 1;
          this.getDraft();
        } else {
          this.$message.warning(res["msg"]);
        }
      });
    },
    drawClose() {
      this.draft_pagination = {
        current: 1,
        total: 0,
        pageSize: 5,
      };
      this.drawVisible = !this.drawVisible;
    },
    pageChange(e) {
      this.draft_pagination.current = e.current;
      this.getDraft();
    },
    /* 自定义方法 --------------------------------  */
    // 写入编译器
    append_to_editor(item, id) {
      this.addPointCount(id);
      if (!this.is_ready) {
        return false;
      }
      if (this.Range && this.Range.collapsed === false) {
        let material = $(item);
        // 替换选区中的内容
        let p_list = this.Range.cloneContents();
        let p_list_max_index = $(p_list).find("p").length - 1;
        // 检查 p_list 中有没有数据
        // if (p_list_max_index < 0) {
        //   console.log($(p_list).text())
        // }
        // 获取到文本
        // console.log(p_list_max_index)
        // 选区选中文本 几个 p 标签

        // 对插入文本中的每一个 p 标签查找要替换的文本 替换中文本不足的跳过
        material.find("p").each(function(index) {
          if (p_list_max_index >= 0) {
            if (index <= p_list_max_index) {
              let replace_html = $(p_list).find("p")[index].innerText;
              $(this).html(replace_html);
            }
          } else {
            if (index === 0) {
              $(this).html($(p_list).text());
            }
          }
        });
        // 写入数据
        let A, B, C;
        // 需要写入的数据
        A = material.html();
        // 获取该节点后面的兄弟节点
        B = window.UE.dom.domUtils.getNextDomNode(this.NowSelect[0]);
        // 获取该节点前面的兄弟节点
        C = window.UE.dom.domUtils.getPreDomNode(this.NowSelect[0]);
        // 防止嵌套分离

        if (C !== null) {
          $(C).after(A);
        } else if (B !== null) {
          $(B).before(A);
        }
        this.NowSelect.remove();
      } else {
        // 从光标处插入
        this.UEInstance.execCommand("insertHtml", item);
      }
    },
    // 复制 html
    clipboard() {
      let content = this.UEInstance;
      console.log(content);

      try {
        var temp = this.UEInstance.getContent();
        this.UEInstance.execCommand("selectall");
        if (this.UEInstance.document.execCommand("copy")) {
          this.$message.success("微信复制成功，请到微信后台粘贴使用。");
        } else {
          this.$message.warning(
            "复制失败，检查浏览器是否屏蔽Flash，请点击顶部导航“帮助中心”或者全选后“Ctrl+C”复制"
          );
        }
        this.UEInstance.setContent(temp);
      } catch (err) {
        this.$message.error(
          "复制失败，检查浏览器是否屏蔽Flash，请点联系开发者或者全选后“Ctrl+C”复制"
        );
      }
    },
    // 预览
    preview() {
      this.screenVisible = true;
      this.screenContent = this.UEInstance.getContent();
    },
    // 手机预览 生成临时链接跳转页面展示数据
    mobile_preview() {
      let content = this.UEInstance.getContent();
      mobilePreview({
        content: content,
      }).then((res) => {
        if (res["code"] === 1) {
          // let url = res['url']
          this.$message.success(res["msg"]);
        } else {
          this.$message.warning(res["msg"]);
        }
      });

      console.log("手机预览");
    },
    closePreview() {
      this.screenVisible = false;
    },
    // 选择屏幕尺寸
    switchScreen(screen) {
      this.nowScreen = screen;
    },
    // 清空
    cleanEditor() {
      this.UEInstance.setContent("");
      this.$message.success("编译器已清空");
    },
    // 复制
    copy_editor() {
      let copy_text;
      if (this.Range && this.Range.collapsed === false) {
        copy_text = this.Range.cloneContents();
        copy_text = $(copy_text).text();
      } else if (this.NowSelect) {
        copy_text = this.NowSelect.prop("outerHTML");
      }
      if (copy_text) {
        let clipboard = new Clipboard(".copy", {
          text: () => {
            return copy_text;
          },
        });
        clipboard.on("success", () => {
          this.$message.success("复制成功");
          // 释放内存
          clipboard.destroy();
        });
      } else {
        this.$message.warning("没有可以复制的内容");
      }
    },
    // 剪切
    cut_editor() {
      let cut_text;
      if (this.Range && this.Range.collapsed === false) {
        cut_text = this.Range.cloneContents();
        cut_text = $(cut_text).text();
        // 删除全区中的文本 / img
        this.Range = this.Range.deleteContents();
        this.Range = null;
      } else if (this.NowSelect) {
        cut_text = this.NowSelect.prop("outerHTML");
        this.NowSelect.remove();
      }
      if (cut_text) {
        let clipboard = new Clipboard(".cut", {
          text: () => {
            return cut_text;
          },
        });
        clipboard.on("success", () => {
          this.$message.success("剪切成功");
          // 释放内存
          clipboard.destroy();
        });
      } else {
        this.$message.warning("没有可以复制的内容");
      }
    },
    // 选中
    select_editor() {
      this.Range = this.NowCursorSelection.getRange();
      this.Range = this.Range.selectNode(this.NowCursorSelection.getStart());
      // 点击时 失焦要重新获取焦点
      this.Range.select();
    },
    // 删除
    remove_editor() {
      // 判断有无选区
      if (this.Range && this.Range.collapsed === false) {
        this.Range = this.Range.deleteContents();
        this.Range = null;
      } else if (this.NowSelect) {
        this.NowSelect.remove();
      }
    },
    // 上移
    move_up_editor() {
      let A, C;
      A = this.NowSelect[0];
      C = window.UE.dom.domUtils.getPreDomNode(this.NowSelect[0]);
      $(C).before(A);
    },
    // 下移
    move_down_editor() {
      let A, C;
      A = this.NowSelect[0];
      C = window.UE.dom.domUtils.getNextDomNode(this.NowSelect[0]);
      $(C).after(A);
    },
    cover_to_img_editor() {},
    // 后空行
    blank_editor() {
      this.NowSelect.after(
        '<section class="_editor"><p class="_editor"> &nbsp;</p></section>'
      );
    },
    // 前空行
    pre_blank_editor() {
      this.NowSelect.before(
        '<section class="_editor"><p class="_editor"> &nbsp;</p></section>'
      );
    },
    // 传递
    colors() {
      let nowDataId = this.NowSelect.attr("data-id");
      let styleList = this.NowSelect.attr("style").split(";");
      styleList = $.grep(styleList, function(item) {
        // 去除 outline
        return !(item === "" || item.indexOf("outline") >= 0);
      });
      styleList = styleList.join(";");
      let bodyJquery = $(this.UEInstance.body);
      let replaceIdList;
      // 遍历所有元素 找到id相同的元素
      replaceIdList = bodyJquery.find("._editor");
      replaceIdList.filter(function(index, item) {
        // 当前选中的不进行替换 其他的进行替换 将style内容替换上 并且删除掉 outline
        if (
          !$(item)
            .attr("class")
            .split(" ")
            .includes("active")
        ) {
          // 找样式id相同的
          if ($(item).attr("data-id") === nowDataId) {
            // 替换
            $(item).attr("style", styleList);
          }
        }
      });
    },
    // 段落
    show_params_editor() {
      this.showParams = !this.showParams;
    },
    show_color_picker() {
      this.colorPickerShow = !this.colorPickerShow;
    },
    // 应用到本样式
    params_this() {
      let property_list = this.getProperty();
      this.NowSelect.find("p").each((index, item) => {
        $(item).css(property_list);
      });
    },
    // 应用到全文
    params_all() {
      let property_list = this.getProperty();
      $(this.UEInstance.body)
        .find("p")
        .each((index, item) => {
          $(item).css(property_list);
        });
    },
    getProperty() {
      let property_list = {
        "line-height": this.line_height + "em", // 行高
        "font-size": this.fontsize + "px", // 字号
        "font-family": this.fontfamily + "px", // 字体
        "letter-spacing": this.letter_spacing + "px", // 字间距
        color: this.color, // 字体
        "text-indent": this.text_indent + "em", // 首行缩进
        "margin-top": this.before_space + "px", // 段前距
        "margin-bottom": this.after_space + "px", // 段后距
      };
      return property_list;
    },

    // 偏移
    show_offset_editor() {
      this.showOffset = !this.showOffset;
    },
    offset_x() {
      if (this.offsetX === 0) {
        this.NowSelect.css("margin-left", "auto");
      } else {
        this.NowSelect.css("margin-left", this.offsetX + "px");
      }
    },
    offset_y() {
      this.NowSelect.css("margin-top", this.offsetY + "px");
    },
    // 替换文字
    replace_editor() {
      this.showReplace = !this.showReplace;
    },
    replace() {
      // this.replaceSrcText
      // this.replaceDestText
      if (!this.replaceSrcText) {
        this.$message.warning("请输入待匹配内容");
      } else if (!this.replaceDestText) {
        this.$message.warning("请输入替换内容");
      } else if (this.replaceSrcText === this.replaceDestText) {
        this.$message.warning("待匹配内容与替换内容相同");
      } else {
        // 查找选中元素中有文本的标签 然后进行替换
        let selectText = this.NowSelect.find("*");
        let text = "";
        selectText = $.map(selectText, (item) => {
          text = $(item)
            .contents()
            .filter(function() {
              return this.nodeType === 3;
            })[0];
          if (!text === false) {
            return item;
          }
        });
        $.each(selectText, (index, item) => {
          //  替换文本
          let str = $(item).text();
          let reg = new RegExp(this.replaceSrcText, "g"); //g,表示全部替换。
          str = str.replace(reg, this.replaceDestText);
          $(item).text(str);
        });
        this.$message.success("替换完成");
      }
    },
    // 清除格式
    clean_editor() {
      // 当前选中区域文字 一段一个写入
      let textArray = this.NowSelect[0].innerText;
      textArray = textArray.split("\n");
      if (textArray.length > 0) {
        textArray.forEach((item) => {
          if (item !== "") {
            this.NowSelect.before(
              '<section class="_editor"><p>' + item + "</p></section>"
            );
          }
        });
        this.NowSelect.remove();
      }
    },
    /* 常驻方法 ----------------------------------- */
    ready(editorInstance) {
      this.is_ready = true;
      this.UEInstance = editorInstance;
      //  弹窗注册
      console.log("弹窗注册");
      this.dialog_global = $("#_pop");
      // 注册监听
      console.log("选区注册");
      this.UEInstance.addListener("selectionChange", () => {
        // 当前点击的节点
        this.NowCursorSelection = this.UEInstance.selection;
        let start = this.NowCursorSelection.getStart();
        this.Range = this.NowCursorSelection.getRange();
        let is_selected = false;
        // 检测开始元素
        window.UE.dom.domUtils.findParent(start, (item) => {
          // 查找当前点击元素的父节点 带有 _editor
          // 当前遍历到的元素 $(item) jquery 对象 找到当前选区元素的 section._editor
          // 第一次匹配到的元素
          if ($(item).is("section._editor") && !is_selected) {
            // 旧的选区删除样式
            if (this.NowSelect !== null) {
              this.NowSelect.removeClass("active");
            }
            // 关闭旧的
            if (this.pop_show) {
              this.p_close();
            }
            this.NowSelect = $(item);
            // 添加选中状态
            this.NowSelect.addClass("active");
            // 获取点击元素的elementCode
            let elementCode = this.NowSelect.data("id");
            // 打开新窗口
            this.p_show();
            this.pop_id = elementCode || 0;

            is_selected = true;
          }
        });
        //  判断有无选中的数据
        if (!is_selected) {
          // 旧的选区删除样式
          if (this.NowSelect !== null) {
            this.NowSelect.removeClass("active");
          }
        }
      });
    },
    _moveOnDraw(evt) {
      let move = false;
      if (this.pop_move) {
        let nodes = ["SECTION", "DIV"];
        if (nodes.includes(evt.toElement.nodeName)) {
          move = true;
          let classNames = evt.toElement.className.split(" ");
          if (classNames.includes("marker")) {
            move = false;
          }
        }
        // 移动
        if (move) {
          this.startX = evt.clientX;
          this.startY = evt.clientY;
          this.d_start_top = this.pop_top;
          this.d_start_left = this.pop_left;
          document.addEventListener("mousemove", this.mousemove);
          document.addEventListener("mouseup", this.mouseup);
        }
      } else {
        this.$message.warning("窗口已被锁住,请解锁");
      }
      document.body.onselectstart = () => {
        return true;
      };
      evt.stopPropagation();
    },
    mousemove(evt) {
      // 当前弹窗的位置
      // console.log('offsetX', this.offsetX)
      // console.log('offsetY', this.offsetY)
      // console.log('evt.clientX', evt.clientX)
      // console.log('evt.clientY', evt.clientY)
      this.pop_left = this.d_start_left + (evt.clientX - this.startX);
      this.pop_top = this.d_start_top + (evt.clientY - this.startY);
    },
    mouseup() {
      document.removeEventListener("mousemove", this.mousemove);
      document.removeEventListener("mouseup", this.mouseup);
    },

    _moveLayout(evt) {
      let move = false;
      let nodes = ["DIV"];
      if (nodes.includes(evt.toElement.nodeName)) {
        move = true;
      }
      if (move) {
        this.startX = evt.clientX;
        this.d_start_left = (this.layout_ratio * 180) / 100 + 1;
        document.addEventListener("mousemove", this.l_mousemove);
        document.addEventListener("mouseup", this.l_mouseup);
      }
      document.body.onselectstart = () => {
        return true;
      };
      evt.stopPropagation();
    },
    l_mousemove(evt) {
      let left = this.d_start_left + (evt.clientX - this.startX);
      if (left <= 0) {
        this.layout_ratio = 0;
      } else if (left >= 181) {
        this.layout_ratio = 100;
      } else {
        this.layout_ratio = Math.floor(((left - 1) / 180) * 100);
      }
    },
    l_mouseup() {
      document.removeEventListener("mousemove", this.l_mousemove);
      document.removeEventListener("mouseup", this.l_mouseup);
    },
    setLayout() {
      this.NowSelect.css({
        width: this.layout_ratio + "%",
        flex: "0 0 " + this.layout_ratio + "%",
      });
    },

    _moveRotate(evt) {
      let move = false;
      let nodes = ["DIV"];
      if (nodes.includes(evt.toElement.nodeName)) {
        move = true;
      }
      if (move) {
        this.startX = evt.clientX;
        this.d_start_left = this.angle_ratio / 2 + 90.5;
        document.addEventListener("mousemove", this.r_mousemove);
        document.addEventListener("mouseup", this.r_mouseup);
      }
      document.body.onselectstart = () => {
        return true;
      };
      evt.stopPropagation();
    },
    r_mousemove(evt) {
      let left = this.d_start_left + (evt.clientX - this.startX);
      if (left <= 0) {
        this.angle_ratio = -180;
      } else if (left >= 181) {
        this.angle_ratio = 180;
      } else {
        this.angle_ratio = left * 2 - 180;
      }
    },
    r_mouseup() {
      document.removeEventListener("mousemove", this.r_mousemove);
      document.removeEventListener("mouseup", this.r_mouseup);
    },
    setAngle() {
      this.NowSelect.css({
        "-webkit-transform": "rotateZ(" + this.angle_ratio + "deg)",
        transform: "rotateZ(" + this.angle_ratio + "deg)",
        "-moz-transform": "rotateZ(" + this.angle_ratio + "deg)",
        "-o-transform": "rotateZ(" + this.angle_ratio + "deg)",
      });
    },

    _moveOpacity(evt) {
      let move = false;
      let nodes = ["DIV"];
      if (nodes.includes(evt.toElement.nodeName)) {
        move = true;
      }
      if (move) {
        this.startX = evt.clientX;
        this.d_start_left = parseInt(this.opacity * 180) + 1;
        document.addEventListener("mousemove", this.o_mousemove);
        document.addEventListener("mouseup", this.o_mouseup);
      }
      document.body.onselectstart = () => {
        return true;
      };
      evt.stopPropagation();
    },
    o_mousemove(evt) {
      let left = this.d_start_left + (evt.clientX - this.startX);

      if (left <= 0) {
        this.opacity = 0;
      } else if (left >= 181) {
        this.opacity = 1;
      } else {
        let num = left / 180;
        this.opacity = num.toFixed(2);
      }
    },
    o_mouseup() {
      document.removeEventListener("mousemove", this.o_mousemove);
      document.removeEventListener("mouseup", this.o_mouseup);
    },
    setOpacity() {
      this.NowSelect.css({ opacity: this.opacity });
    },
    // 点击样式初始化点击框
    p_show() {
      if (!this.pop_show) {
        this.dialog_global.css("display", "");
        this.pop_show = !this.pop_show;
        // 偏移量
        let x = this.NowSelect.css("margin-left");
        let y = this.NowSelect.css("margin-top");
        // 宽度比
        let layout = this.NowSelect.css("flex");
        layout = layout.split(" ");
        layout = layout[layout.length - 1];
        if (layout === "auto") {
          this.layout_ratio = 100;
        } else {
          this.layout_ratio = layout.substring(0, layout.length - 1);
        }
        // 转角度
        let transform = this.NowSelect.css("transform");
        // 透明度
        let opacity = this.NowSelect.css("opacity");
        this.offsetX = x.substring(0, x.length - 2);
        this.offsetY = x.substring(0, y.length - 2);
        this.opacity = opacity;
        // 转角度
        if (transform === "none") {
          this.angle_ratio = 0;
        } else {
          let t = transform.substring(7, transform.length - 1);
          let t_array = t.split(",");

          let s = this.getmatrix(
            t_array[0],
            t_array[1],
            t_array[2],
            t_array[3],
            0,
            0
          );
          if (s > 180) {
            s = s - 360;
          }
          this.angle_ratio = s;
        }
        // 额外属性
        let line_height = this.NowSelect.css("line-height");
        let fontsize = this.NowSelect.css("font-size");
        let fontfamily = this.NowSelect.css("font-family");
        let letter_spacing = this.NowSelect.css("letter-spacing");
        let color = this.NowSelect.css("color");
        let text_indent = this.NowSelect.css("text-indent");
        let before_space = this.NowSelect.css("margin-top");
        let after_space = this.NowSelect.css("margin-bottom");

        if (line_height === "normal") {
          this.line_height = 1.5;
        }
        this.fontsize = fontsize.substring(0, fontsize.length - 2);
        this.fontfamily = fontfamily;

        if (letter_spacing === 0) {
          this.letter_spacing = 0;
        } else {
          this.letter_spacing = letter_spacing.substring(
            0,
            letter_spacing.length - 2
          );
        }

        if (color.indexOf("#") === -1) {
          // rgb 颜色

          this.color = this.colorRGB2Hex(color);
        } else {
          this.color = color;
        }

        this.text_indent = text_indent.substring(0, text_indent.length - 2);
        this.before_space = before_space.substring(0, before_space.length - 2);
        this.after_space = after_space.substring(0, after_space.length - 2);

        // console.log('color', color)
        // console.log('fontsize', fontsize)
        // console.log('fontfamily', fontfamily)
        // console.log('text_indent', text_indent)
        // console.log('line_height', line_height)
        // console.log('after_space', after_space)
        // console.log('before_space', before_space)
        // console.log('letter_spacing', letter_spacing)
        // let property_list = {
        //   'line-height': this.line_height + 'em',          // 行高
        //   'font-size': this.fontsize + 'px',               // 字号
        //   'letter-spacing': this.letter_spacing + 'px',    // 字间距
        //   'color': this.color,                             // 字体
        //   'text-indent': this.text_indent + 'em',          // 首行缩进
        //   'margin-top': this.before_space + 'px',          // 段前距
        //   'margin-button': this.after_space + 'px',        // 段后距
        // }
      }
    },
    p_close() {
      if (this.pop_show) {
        this.dialog_global.css("display", "none");
        this.pop_show = !this.pop_show;
        this.colorPickerShow = false;
        this.showParams = false;
        this.showOffset = false;
        this.showReplace = false;
      }
    },
    tran_lock() {
      this.pop_move = !this.pop_move;
    },
    /* --------------------------------- */
    // 登出操作
    logout() {
      // 加提示
      this.$confirm({
        title: "退出",
        content: "确定退出?",
        okText: "确认退出",
        cancelText: "取消",
        onOk: () => {
          // 清空缓存
          store.commit("SET_MENUS", []);
          store.commit("SET_ROLES", []);
          store.commit("SET_USER_INFO", {});
          localStorage.clear();
          this.jump("/user/login");
        },
        onCancel() {},
      });
    },
    jump(key) {
      this.$router.push({ path: key, replace: true });
    },
    safeSetOffset(offset) {
      let me = this.dialog_global;
      let el = me[0];
      let vpRect = window.UE.uiUtils.getViewportRect();
      let rect = window.UE.uiUtils.getClientRect(el);
      let left = offset.left;
      if (left + rect.width > vpRect.right) {
        left = vpRect.right - rect.width;
      }
      let top = offset.top;
      if (top + rect.height > vpRect.bottom) {
        top = vpRect.bottom - rect.height;
      }
      el.style.left = Math.max(left, 0) + "px";
      el.style.top = Math.max(top, 0) + "px";
    },
    getmatrix(a, b, c, d, e, f) {
      let aa = Math.round((180 * Math.asin(a)) / Math.PI);
      let bb = Math.round((180 * Math.acos(b)) / Math.PI);
      let cc = Math.round((180 * Math.asin(c)) / Math.PI);
      let dd = Math.round((180 * Math.acos(d)) / Math.PI);
      console.log(e, f);
      let deg = 0;
      if (aa === bb || -aa === bb) {
        deg = dd;
      } else if (-aa + bb === 180) {
        deg = 180 + cc;
      } else if (aa + bb === 180) {
        deg = 360 - cc || 360 - dd;
      }
      return deg >= 360 ? 0 : deg;
    },
    colorRGB2Hex(color) {
      let rgb = color.split(",");
      let r = parseInt(rgb[0].split("(")[1]);
      let g = parseInt(rgb[1]);
      let b = parseInt(rgb[2].split(")")[0]);

      return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },
    // 滚动监听
    scrollListing() {
      //滚动到的当前位置
      let Tag = $("#ListingTag");
      let nScrollHeight = Tag[0].scrollHeight; //滚动距离总长(注意不是滚动条的长度)
      let nScrollTop = Tag[0].scrollTop; //滚动到的当前位置
      let nDivHeight = Tag.height();

      if (nScrollTop + nDivHeight >= nScrollHeight) {
        if (this.loading) {
          this.$message.loading({ content: "素材加载中...", key });
        }
        if (this.noData) {
          this.$message.warning({ content: "没有素材了", key });
        }
        if (!this.loading && !this.noData) {
          this.current = this.current + 1;
          this.getData();
        }
      }
    },
  },
  watch: {
    // 宽度比
    layout_ratio(val) {
      if (val === "") {
        this.layout_ratio = 0;
      }
      if (val < 0) {
        this.layout_ratio = 0;
      } else if (val > 100) {
        this.layout_ratio = 100;
      } else {
        this.layout_ratio = val;
        this.setLayout();
      }
    },
    // 角度比
    angle_ratio(val) {
      if (val === "") {
        this.angle_ratio = 0;
      }
      if (val < -180) {
        this.angle_ratio = -180;
      } else if (val > 180) {
        this.angle_ratio = 180;
      } else {
        this.angle_ratio = val;
        this.setAngle();
      }
    },
    // 透明度
    opacity(val) {
      if (val === "") {
        this.opacity = 1;
      }
      if (val < 0) {
        this.opacity = 0;
      } else if (val > 1) {
        this.opacity = 1;
      } else {
        this.opacity = val;
        this.setOpacity();
      }
    },
    color_picker(val) {
      this.color = val.hex;
    },
  },
};
</script>

<style scoped>
ul {
  list-style: none;
}

#components-layout-demo-top .logo {
  display: flex;
  width: 150px;
  height: 29px;
  margin: 16px 0;
  float: left;
  cursor: pointer;
}

.vd-layout-header-right {
  float: right;
  padding: 0 24px;
  cursor: pointer;
  color: white;
}

.element-show-list {
  width: 400px;
  z-index: 999;
  background-color: white;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
}

.element-content {
  display: flex;
  flex-direction: column;
  border-width: 1px;
  border-style: solid;
  border-color: #eeeeee;
  width: 400px;
  height: calc(100vh - 64px);
  box-sizing: border-box;
}

.search-bar {
  display: flex;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
}

.search-input {
  line-height: 25px;
  display: flex;
  margin-left: 10px;
  border-radius: 10px;
  border-width: 1px 1px 1px 1px;
  border-style: solid;
  border-color: rgba(239, 239, 239, 1);
}

.search-input:focus-within {
  border-color: rgba(202, 221, 255, 1);
}

.search-input input {
  outline: none;
  width: 100px;
  border: initial;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.search-input span {
  padding-right: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  cursor: pointer;
}

.search-span {
  display: block;
  margin: 0 5px;
  cursor: pointer;
}

.data-main {
  display: flex;
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.data-main::-webkit-scrollbar {
  width: 1px;
}

.data-main::-webkit-scrollbar-track {
  display: none;
}

.item-option {
  position: relative;
  border-bottom: 1px dotted #ddd;
  padding: 0 15px;
  font-size: 16px;
  cursor: pointer;
  width: 400px;
}

.item-option:hover {
  box-shadow: inset 0 0 8px 0 #444;
}

.item-favour {
  display: flex;
  justify-content: flex-end;
  padding: 5px 0;
}

.editor-tool-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.editor-tool-button button {
  padding: 5px 0;
  font-size: 13px;
  font-weight: bolder;
  border: 1px solid #fff;
  width: 110px;
  cursor: pointer;
  line-height: 25px;
  margin-bottom: 7px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  background-color: #fff;
  -webkit-box-shadow: 0 4px 10px 0 rgba(202, 221, 255, 0.3);
  box-shadow: 0 4px 10px 0 rgba(202, 221, 255, 0.3);
  text-align: center;
}

.editor-tool-button button:hover {
  box-shadow: 0 4px 10px 0 rgba(202, 221, 255, 1);
}

.editor-tool-button button:focus {
  outline: 0;
}

/* 遮罩层相关 */
.preview-modal {
  position: absolute;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.3);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.screenPlus5Content {
  position: relative;
  width: 313px;
  height: 564px;
  margin-top: 92px;
  margin-left: 22px;
  padding: 5px 10px;
  border: none;
  overflow-y: auto;
}

.screenPlus5Content::-webkit-scrollbar {
  display: block;
  width: 8px;
  height: 1px;
}

.screenPlus5Content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #c0c4cc !important;
}

.screenPlus5Content::-webkit-scrollbar-track {
  border-radius: 10px;
  background: #ededed;
}

.screen5Content {
  position: relative;
  width: 301px;
  height: 492px;
  margin-top: 124px;
  margin-left: 24px;
  padding: 5px 10px;
  border: none;
  overflow-y: auto;
}

.screen5Content::-webkit-scrollbar {
  display: block;
  width: 8px;
  height: 1px;
}

.screen5Content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #c0c4cc !important;
}

.screen5Content::-webkit-scrollbar-track {
  border-radius: 10px;
  background: #ededed;
}

.screenDown5Content {
  position: relative;
  width: 269px;
  height: 435px;
  margin-top: 120px;
  margin-left: 25px;
  padding: 5px 10px;
  border: none;
  overflow-y: auto;
}

.screenDown5Content::-webkit-scrollbar {
  display: block;
  width: 8px;
  height: 1px;
}

.screenDown5Content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #c0c4cc !important;
}

.screenDown5Content::-webkit-scrollbar-track {
  border-radius: 10px;
  background: #ededed;
}

.screenPlus5 {
  all: unset;

  width: 352px;
  height: 723px;
  background: url("data:image/jpeg;base64,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");
}

.screen5 {
  all: unset;
  width: 344px;
  height: 708px;
  background: url("data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAVoAAALGCAYAAAAEHVnTAAAgAElEQVR4nO3dCZRcdb3g8V9C2BIgJCDqAxRw3FBBcWNgdBQeT1RQFAWfiDjuHgFROa644sa4MA9FReW5PBXFjWFRVISjAjKugwjiAuiwiGxZIGFP5vzuqxurO9VJL/Xrrko+n3P6kG66q2/fqvrW//7vrXtn3X777TGgto+IXSPikRHxoIjYISIWdD7mRcRmnf8C64eVEbE4Iu6IiJsj4vqI+EtEXBERv4uIiyPi6kFcE4MU2u0iYt+I2Cci9oyIbQdgmYDhcm1EXBARP4yIsyPimkFY+pkO7fyIODgiDomIJ+XyzOTCAOuUHAGfHxFfjoivR8SSmfrjZiq0u0fEGyJi/4jYZCYWAFiv3BkRp0fExyLioun+w6c7tE+NiGMiYq/p/KUAXc6LiGM7/50W0xXaHMF+pDP3CjAILoyIN07HCHd28e3fJyL+o/MHiSwwSPbotOk/Oq0qUxnaF0TE7yPiRXZyAQNqVqdRv+80q0RFaHPn1kkRcUpEbOXRBQyBrTrNOqliB32/52gf1lnYR/fzRgGm0cWd0e3l/fqV/RzR/ktE/FxkgSG3a6dlT+vXn9Gv0B4WEWdFxOZ9uj2AmZQtOzMi/kc/lqEfoX1tRHw+Iub04bYABkU27eSIOHyqyzPV0L46Ij7uqAJgHZVtOyEiXjOVP28qO8MO6Rx/JrLAui7Pm3BoRHxlMn/nZEObb6H9XkRs5OEFrCfuioinR8S5E/1zJxPaPC/sLyJia48uYD2T58F9XOc8uOM20TnajSPiWyILrKe26jRw44n8+RMN7YciYjePMGA9tlunheM2kamDvTtnLbfzC1jfrey8Seuc8ayH8YZ2bkT8tnPtLgAiroyIXSJi2drWxXinDo4RWYARduq0ca3GM6LdMSIuc8kZgNXkFXl3joir1rRqxjOiPVZkAXrKNr5vbatmbSPaLPUl03AlBoBhtaIzV3vpWMu/toC+WWQB1igb+aY1fcOaRrTbRcQV3mYLsFb59tz/EhFX9/rGNY1WXy6yAOOSrXzZWN841oh2due9vNtbxwDjcnXnKK17R3/zWCPap4gswIRkM/97rx8YK7QHWb8AE9aznb2mDvJcBtdExD9ZxwATcl3nQIKV3T/Ua0S7i8gCTMo/da6iO0Kv0O5l/QJM2moN7RXaPa1fgEnbY/QP9grt461fgElbraGjQ7swIh5g/QJM2gM6LV1ldGh3tm4BpmxES0eHdgfrF2DKRrR0dGgfaP0CTNmIls4ZdWsuI74OWLlyZSxdujTaN6NsuummscUWW8SsWeO7rmb3z69YsWK9XIezZ8+e8HqDLvfp/mR0aLeypoZfRnLZsn9cLy7/nbHIaIzH6J9fH+ULzETXG3RZ486wedbU8Ot1Rrbly5eP+++awCXo13kTWW/QZURLR4d2Y2sKYMpGtNRlatZBObc42ty5c8f9h/b6+fXVRNYbjGX0HC3rgHZOsXtn2Oabbz7uP6z759f3nWETWW8wFqFdB+UOnPnz5zcfkzHVnwdGMnUAUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUCxOf2++bvvvjs+8pGPxJlnnhlLlixx/wFDZYsttoj9998/jj766Nhwww37suh9D+1HP/rR+MpXvtLvmwWYFkuXLm0atskmm8TrX//6vvzKWbfffnv352dGxDOncoN77rlnM5LNV4Ijjjgi9t133+YVAmCQ3XrrrfG9730vPv7xjzdb5vPnz48LLrhgskt8VkTs137S9xFtO11w+OGHx0EHHdTvmwcosfnmmzfNuvPOO+PEE0/s69Rn2c6wpz/96VU3DVDm2c9+dt9vuiy0pguAYVTRLod3ARTr+xxtPy1btiw22mijtR5ikd+X5s2b5/ECfZJzld/61rfihS984cCs0j/84Q9x/fXXN02YNWvWhH525cqVcdddd8VDH/rQuP/971+2jL0M7Ij2F7/4RTziEY+IxzzmMXHzzTev9v9/8pOfxCte8Yp44AMfGDvssEPzseOOO8ZrXvOa+NnPfjYjy8zaXXnllfHJT34yLrroorV+73XXXdc8Du64445VX8snSn5t1NEyq+Rj5Ze//OWIr1199dWrfS396le/ir/+9a/utTFsvPHG8Za3vCUe97jHxT333LPG7/3b3/4Wl1122Yivffvb347Pfe5zq31vHmP/2c9+Nu69995VX/vBD34QP/rRj0Z8369//esRn+djJu+zrbbaqtlxtdlmm03oI39myy23jO9///txxRVX9G09jcdAjWh//OMfNw/85z3vebFo0aJmpJofN9xwQ7Ny01VXXRUf+MAH4rTTTms+z7jmIWX5avXTn/40vvnNbzYfz3/+85sHyQMe8IAZ/qto5RPv1a9+dey6667xrne9K9797nfHa1/72uYJl3t480kwe/Z/vvbfdtttzfelc845p/l3PhFf/vKXN//vhz/8YTz60Y9ebd3mC+15553XHJbzkIc8pPnaySef3OxFzifYbrvt1nwtn2h56OELXvCC5nAe/uGPf/xjvO9974svfvGLccghh8Ty5cvjOc95Thx33HGx8847j/jefN7l/XrUUUfFE5/4xOa5l97//vc390MOgPJ5nfdBbp22b2bKUWXeh6eeempz/2Z4c4SaL6D77bdfvO51r2vi2N5f6aabbmoGXp/+9Kd7Dr7G4/GPf3w89alPjcsvvzwe9KAHTdu9PlChzU2UHLHk8WvdK7h76uALX/hCE9m849/73vfGnDlzVo143vGOdzSbOxnYb3zjG81o981vfvOM/C2s7lWvelVzbPU73/nOJpoZucMOO6x5Uc37O49hzNFTevGLX9xs0WSA8zGR8sn4tKc9Lb773e/2HNHmEzFfqPPxk0/Gj33sY83X8/P0qU99qrmNlKPqtHDhQvfUKNtuu23znNpjjz2aj7xvzj333BFbFq2///3vcckllzQvcDkISn/605/iO9/5zqqtiGc84xlNjJ/73OfG1772tTj//PObNwMccMABTYwvvvjiOPDAA5tjV//85z/Hb37zmyb2GeRuubmfWydf/epXJ/23XXjhhfGkJz2pud9vueWWZtQ+HVOOMzp1cPrppzeHgeUINW2zzTbNfzOW+UrZSz5R89UxX3Ezug9/+MObV7n8eNjDHtbcCR/+8IebTZZXvvKVM/nn0UOOalKOVlI+6fIJdNJJJ8VOO+3UfC2fjPnky8dHBrUNbd63OSLKr61YsWK1G//MZz7TjHzz5/LFuN3cXbx4cfPYyidwvusnH1u5GZp7l3N0zEgZnhxp5mDmS1/6UvNcyqm67sFPK7c0c8vkyU9+8qrjTjNmj3zkI1d9z1577dVMGeX6z+doRjbts88+zYvrS17ykuY++/nPfx67775780J81llnxQYbbDDid+WWz+ivTVQ+1vKxk1tPZ5999pSiPRHdI9r8d3/e2LsGb3/725uQfuhDH2pWbL7qXXvttfG2t70tNt100+YHcwQ7Vmi33nrreNazntWMZnOTL0dA+eaIXHk5gsnNm9z8fMMb3lD9pzBBuSmaL34Z14zq/e53v7jxxhubrZIc7URnhJRbIRnKDGGOOtoo5/2aj5XUa0dI/syjHvWo5t/5Lp/cJM3pgdzM3HvvvZsRWT6xMiQ5rZBTD/n76a19DuZ/c36zl3ZrM7cm8n6MzkCpfUGNzotrfi1f5Lq3TnM0mfd3xjpjnp+/7GUva6YrPv/5zzcvqPncrpDBzuXJ3z8dcs3MzS2piPjXXCfVvzNHHelNb3pT8+qW7nvf+666Q8cr74CMbM4ZtZsseefkhHzO2TJ48v5qR5q5eXrKKafELrvs0oTw2GOPbeb18sU35wTznBn55M3HRMY5NyPvc5/7jPkYyZ0x+TjIJ3X7Ipubqxna9rH11re+tfk8R8g5ksrpg14j4/VdTuXkKDM35XMKJ+dZcwohY5j3Vy/dL3z5/Wecccaqz3M6J19Uc+uzO2w5ym0DPnfu3Ob+z8dI/jt3hOXWRv7OnJePzu/IZZqKfGzlYyFvO+eUpzpCHq+cOjg+Ig6bjsh2yxWWo47obNqlHL2kfCXrXqG9Vm7OseTcT25m5tvm8iPv3PxaOyfHYMmtmZyTzYDmCDY38/Mj7/fcMZL/zfmz448/Ph772Mc2Oy5SjlLbEVI7jZBPmG65ky2fiLnjJaOcU0s5T5g7U3OTM3eO5Y7TjHw+yfJFPkfW7QiZf8jn5ROe8IRmLjxDlEd/rO0g/hwdXnPNNc2/n/KUpzQj2A9+8IPNfZHzsLkVut122zX/P3eE5m3nRwY9OvPv+RjIAVRu5eYod8GCBSN2emUXMtjtyHkycgoppw3aHWtjvXD0Wy7xwdP5GMsVmHdCxjB3VuVmXLu5l0+6HNFsv/32TUjz/+VmYzt320uOXnI+Lzc78snG4DrhhBOa2OYUT0Y0P08PfvCD49JLL1213C960YtW/TsfKzkHmKOc6DxRcpSV0eyWT5j8uXaE8tKXvjR+97vfNfOGGfUcTUVnv0DeZsroj7VJvD7LI3Xyfkq5Uzmfqzmn3c6t9pLP4bxfojNVkHPuxxxzTHO/ZnDzKIPobNHmNGGOZnMrpt35mXH/xCc+0fw798Pkz+Z93X32rIx5vsDmsb3tIG2icus5ezHdx9Hm2bvGv70+Du0k+FjHSeaIJEeo7Z6+HHF07/Xr/ny8b1gA+i9fkDK0OWc60TcHVMgtkRwd5+i6feGdqJwWyRFxjrrbQwl7yZ1yKV+sJ6n27F1rk+HsnigffWhF9+fe6QUzJ7cSu7cuZlpu3eYJuYeRcx0AFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUm/HQHnzwwc3lKdYk387bvo8aYNjMeGjz3KN5AovR1wdqZWTf8573xNFHHz0TiwcwZTMe2jxre15hIc/o0+tibBnZPJn3dJ3ODKDfBmKOtldsRRZYVwzMxRm7Y5sX7fv6178ussA6YaCOOsjYZmTzCqaHHnqoyALrhIEKbU4X5Ej2yCOPbK6+OdYOMoBhMjBTB+2cbF4dNy9pk5e+yGmEnE7odZljgGExECPa0ZFNeXG+vCpmr6MRAIbJjIe2V2RbYgusC2Y8tHlt/V6RbbWxPfHEE2di8QCmLOdo82Ls283UqsydXmuTsT355JPd28BQyhHth911AHUytCdExGER8aOIWGJdA/RXO0eb2+//HBHnW78A/eV8tADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKFZ2Ptqtt97afQes98KIFqCe0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNAC9N/9I2LviNgkhBagxG4RcU5EXBYROwotQJ0dI+JEoQWotbfQAtTaSGgBirWhPTAi/ndEPNEKB+ivORHxyog4yXoFqJEj2mOsW4A6GdrtrV+AOnaGARQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAWsuFFqDWt4UWoM53I+J1c6xggL47PyIOjojrwhwtQIklbWRDaAHqZWj/Yj0D1MnQHmv9AtTJ0P57RDw7D0GIiJusa4D+audoT4+IAyPi/1i/AP1lZxhAMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxTK0G0XEv0XEzRHxTCscoL/yUjb/MyKOtF4BauSI9lDrFqBOhnah9QtQx84wgGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFMrT3WskAdTK0v7V+AepkaI+KiMXWMUCNDO1PIuIRneBeYT0D9Fe7M+y6iPi3iLjc+gXoL0cdABQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQTGgBigktQDGhBSgmtADFhBagmNACFCsL7eLFi913wNCpaFdZaE877bSqmwYoc+qpp/b9puf0+wbnz58fS5YsieOOOy5mzZoVBxxwQPM1gEGW3coB4vHHH7+qZf3S99Duv//+8eUvfznuvvvuOPbYY5sPgGFz4IEHDm5o3/jGN8bKlSvjjDPOiKVLl/b75gFKbbHFFs2A8Ygjjujbr5l1++23d39+ZkQ8090IMCVnRcR+7Q04vAugmNACFBNagGJCC1BMaAGKCS1AMaEFKCa0AMWEFqCY0AIUE1qAYkILUExoAYoJLUAxoQUoJrQAxYQWoJjQAhQTWoBiQgtQrO9XwYXJWrFiRdx5551x1113xT333BP33ntv87W8qnKaNWtWzJ49OzbYYIOYM2dObLTRRrHxxhs3X4NBJrTMqAzp8uXLI6/GfPfdd69xUTK4+f0Z4QzysmXLmq9vuOGGsemmm8bcuXNFl4EktMyIHK1mKPOje8TajlJzxJofGc78eowKbRvbHP1moPPj1ltvbWK72WabNaNeGBRCy7S77bbbmii2gc2wZiA32WSTVVHtpZ06yACnDGrexh133NGMittRbv578803j3nz5q3x9mC6CC3TJkehixYtWjVFkGHNIOam/2RlSHPaID/aUW2Gd+nSpc10xIIFC1aFGWaKRyDTIuOXkc0RaG7Wb7nlls1Itp8y2AsXLmxGtosXL27Ce+ONNzaxzajDTLHngHK5KX/LLbc0kc2R5zbbbNP3yHbL287fkb8rf2f+7lwGmClGtJTKOdMlS5Y0vyKnCfJjOuSUQjttkNMJOcLN6Oa8LUw3I1rK5HRBG9n58+dPW2S75e/M351yWXKZYLoJLSXaHV/Rid1MjiTzd7eRz2XKZYPpJLT0XW6itzu+cp50Jkayo+UytHO27bLBdBFa+i7nZXOPfx5d0G62D4JcllymXLb2XWUwHYSWvsp3fOXOp5SHcA3SW2JzWXKZUi5jLitMy2PPWqaf8l1fuVmex61WHsI1WblMuWy5jLmsMB2Elr5pTxATnTnRQdUuWy5rLjNUE1r6Jt/ymiPFHDVO5W211XLZchlzWXOZoZrQ0jftaDZPEDPo2mX0jjGmg9DSF7kJnnvz8x1Zw3BegfZMYbnMdopRTWjpizyRS8rzyQ7DqQnbc9+mPKctVBJa+qKN1SAeaTCWdlmFlmpCS1+0b2sdpnO/tsvqLblUE1r6op3nHMbQmqOlmtDSF22shuniiO2yCi3VhJa+6L7A4rDovugjVBJa1nsu4Eg1oaUvhnF0OIyjcIaT0NIXefrB6LxxYVi0yzpM88oMp9GPsDvdj0xGG9phOlSqXdZ22aGPRrR0dGidDZlJGcZjUofx2F+GxoiWjg7tze5HJqN9O2v7Vtxh0P22YeizW7pvbnRob7S2mYzut7MOww6xXMb2rbdCS4Ebum9ydGivsMaZjNyhlOd5zYANwyW9cxlzWXOZzdFSYERLR4f299Y4kzVM53htlzGvjAsFRrR0dGj/nEe9WOtMRkYrj0nNuc88z+ugymXLZcxlHYaTlDN0VnRausro0ObL/NXuVyYjpw/acLVXwh1E7bLlsjqGlgJXd1q6Sq9H2UXWPJO12WabNSPFnAMdxCMQcply2XIZc1mhwC9H32Sv0J5nzTNZuWOpvcrs4sWLB+qdYrnzK5cpOlfCtROMIheOvtleoT3X2mcq5s2b1+zNz9MPLlmyZGDWZUY2lymXLZcRiqw2WO0V2j9FxDXuASYrN8sXLFjQ/Dcv5z0I87W5DLks3csGBa6LiP87+mbH2hNwlnuAqci3tWbQohO5Zctm7t3d+bvb2Ocyecsthc7IWarRNz9WaE91TzBVeUnv+fPnN7eSUwgzMbLN39lOX+SyDMOl0BlqPds5Kzenesi9BFdFxPbuc6Yq3xzQ7oTKY2233HLL8k33dsdX+/jO3+mYWYrllOsOeXWk0b9mrBFtfuO/u1fohwzcwoULV83Z3nDDDaWHfuVt5+9o52Tzd4ss0+DkXpGNNYxoozOazXc3OOMGfZGnJVy0aNGqd43lZnweZpVHAfRD3m5OFbTnWsjbNSfLNMkzFD04Iv5fr1+3ptCmL0bEi91T9Etu0rc7p9qzfOWZv3LEmeGd6JRCexKbnJ5oR8ntmxHaN0/ANPhSRBw21q9ZW2gfERG/dckb+i2PZ83g5kf3tbvylIUZ3hyF5ke+Rbb7emT5BogcGedHhrX7tIztuQsysN6MwDTKd+XsEhGXjvUr1xba9JWIeKF7jQoZzhyN5uNwsieiySmC3Mnm3AXMkFPW1sjxhHbHiLgsp9Tci1TK6Laj1Byx5qg3v9Y9Ys2Q5mg1R7vt6FdcmUE5X/XwzlFaYxrPXoK8gf8VEW9xb1Ipg5kjU+eIZYgcv7bIxjhHtGleZ652J48AgMaVnbnZtb7tcbzbXHlDr+z11jKA9VC28FXjvXL4RCa3fhQRx3lEAcQJEXHOeFfDeKcOWnM6pwD7b9YzsJ76TUTskdf4HO+fP9Hdtfd0DmO4ySMMWA/dHBHPnUhkY5JvRMjr4RzcecsZwPoim3dQRPxlon/vZA9AzKswvNTOMWA9sbLTvEldgWYqR3rnO8YOF1tgHZeNO6LTvEmZ6ltqPhkRR4otsI5a2WnciVP58/rx3sVPRMTLOjvKANYV2bSXdxo3JRM9vGtN/iUivplXcvYwA4ZcXnfp+RHx/X78Gf08G8cPIuIJva4ACTBELu60rC+RjYLzzF4eEf81Ij7T59sFmA7Zrt07LeubivPL3dF5D/C/dg7uBRh0N3ea9aqJvhlhPCpP5Pm1iNg5Ir7sqARgQK3sNGrnTrNKVJ8x+YaIOLTzvuALPdKAAXJhp02HdlpVZrpOTX9RROwZEf/cOSkNwEw5r9OiPTttKtfPw7smIl9FjoqIZ+VFUD3cgGJ5yZnTO1eLmfat65kKbWvLzkkaDu28urg2NNAvKztRzUuBfyMiFs3Ump3p0HbbLiL2jYh9OtHddlAWDBga10bEBRHxw4g4O20PI8AAAABESURBVCKuGYQFH6TQjrZ9ROwaEY/qXKtsh4i4X0RsFRFzI2L+YC0uMA2WRMTyzuFY13dOWZjX7rqk80aDPI3rYImI/w9CBwgh/2LjUAAAAABJRU5ErkJggg==");
}

.screenDown5 {
  all: unset;
  width: 315px;
  height: 635px;
  background: url("data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAAJ9CAYAAACo6c5SAAAdLklEQVR4nO3dCZAddb3o8V9CCGsgCVdLXLlCXaVQREABdykX1EIBFXEJcLn63nNFloev3FBRC3BBXHF9bPoQFCixLCz39Qoiok9EKFZFrqIkQAhhTV79+nWnDoeZyczknNl+n0/VVIZh5kxP9+nv+fdyuuetXr06ZqCNImLHiHhC+7Fd+/EvEbFNRGwSEYtm4oRDAfdExB0RcWv778qIuL79+EP7cUVE3D/TZsVMCd68iNglIvaJiL0jYg9Bg1ktI3hRRPwwIi6MiMsiYu10/0HTHbztI2JZRLyu/RyYm66JiDMj4oz282kxHcFbEBEHRcQbI2KvdnQH1JCjvP+MiM9FxFkRcd9U/tVTGbyFEXFIRLzDaA5oR3onRMRp7X7BoZuK4M2PiEMj4v0R8UhLGehzY0QcGxGnRsSaYc6cYQdv94j4fETsOsxfAswJl0bEf4+IS4b1x8wf0uNuHBEnttvqYgeMx65tM05sGzJwwxjh/WtEnN2O7gAmI0d5B0bEdYOce4Me4e3XDkvFDtgQu7ct2W+Qc3FQwctTSz4QEedGxOIBPSZQW7bkvLYtAzl9bRCbtPk2sK9ExMG1lw0wRKdHxGEb+na1DR3h5bl154gdMGQHt61ZuCG/ZkOClyO7/xMR+1vSwBTYv23ORpP9VZMN3rz2JMEDLGVgCh3QtmdS+/QmG7wPtm/4B5hq2Z4PT+Z3TuagxSsj4uve9A9Mo7wIwava/XrjNtHg5UU5L46ILS1pYJrlxUef2l5sdFwmskm7SXs5F7EDZoIt2yZtMt5pmUjwjouInS1mYAbZuT2mMC7j3aTdrb1c86QPBwMMSZ6MvOd4rrIynhFefs8pYgfMUBu1jVpvz8YTvMNcDACY4XZrWzWm9W3SbhYRV0fEwy1tYIa7KSJ2iIhRo7a+Ed7/EDtglnh4e3OwUY01wlvY3lh3W0sbmCX+q71p/4g3BRprhHeQ2AGzzLZtu0Y0VvDeYkkDs9Co7RoteHky31MsaWAWespob5IYLXjLLGVgFhuxYSMdtMiroFzb7vgDmI1uaO+guLZ32kca4e0sdsAs95iIeFL/nzBS8F5kSQNzwD79f8JIwdvbkgbmgAe1rH8fXr4Jd0VELLK0Z6+1a9fG7bffHt2y3WyzzWKrrbaKefPGd5Hq3p9fs2ZNyXk4f/78Cc83ZpyVEbGk99aO/SO8x4nd7JexWrVqVROr/MjPV65cOe6/q/fnq5rMfGPGWdRepX2d/uDtYpnNfiO9XfDOO+8c9981gJuzzxkTmW/MSA84H68/eDtaZsAcslPvn9IfvMda0rNf7nvqt/nmm4/77xrp56uayHxjRnrAKXYL+qbw0ZbZ7Jc72qNn0zQDtmjR+HfN9v589YMWE5lvzEgPaFr/UdorI+LfLDdgjriqPRjb6N+kXWopA3PIA5rWH7xNLWlgDnnAPWv7g+cm28Bc8oCdsBO5ETfArCZ4QBmCB5QheEAZggeUIXhAGYIHlCF4QBmCB5QheEAZggeUIXhAGYIHlCF4QBmCB5QheEAZggeUIXhAGYIHlCF4QBmCB5QheEAZggeUIXhAGQuG8Yfee++98dGPfjS+/e1vx2233ebZBIzbVlttFfvuu28cffTRsfHGGw90xg0leB/72Mfiq1/96jAeGpjjbr/99qYfm266aRxxxBED/WPnrV69uve/1w7iQZ/+9Kc3I7us85ve9KZ4wQte0FQbYDQrV66M7373u/HZz3622Urceuut4xe/+MUg5te87pOhjPC6zdg3vvGN8YpXvGIYvwKYYxYtWtT04u67745TTjllKLvDhnrQ4oUvfOEwHx6Yg3L/3bAMNXg2Y4GJGmY3nJYClDGUfXgb6v7774+vfOUrcccdd8Rb3vKWBx2a/vvf/x4/+tGP4vLLL4+1a9fG4x73uHje854X2267rWfuFLrvvvtiwYIZ+RSa8372s5/FSSedFF/72teao5kTMdJyy4OXm2222ZiPkuvlRhtt1Hx+5ZVXxp///Od47GMfu+5r45Hr69/+9rfm36c97WlTvphm1LM1Z+DixYtj/vz5ceyxxzZfe9GLXhSPf/zjm89vueWW+MAHPhDnnHPOiD//0pe+NN73vvfFwx72sCmd7oo++clPxvnnn98cTfvgBz8Yz372s0ecC3k+5ne+8534whe+EDvssEP85je/aZbRM5/5zDjmmGMe9P2vetWrmufA5z//+ea/f/3rXzff/6lPfapZudK3vvWt+NznPhdf//rXy+02yRf5W2+9NR7zmMfEtddeG8cdd1wccMABsdtuuz3oe3P+nH322XHyySfHIx/5yLjooovi4x//ePP/8uyJXGZ5ZDTXqVy3dtpppzjqqKPi0ksvbb4vz7bIA4833nhjs/ze8Y53xBZbbBF33nlnXH/99U1oc9lmvObNmzfC1D5Q9325Pt9zzz3N9HfLdKrMmOD99re/jZe85CWx6667xje+8Y3m1SZfdXImRTuznvWsZ8WKFSuaGZ8HRPJ7Mo6rVq2Kn/zkJ/H+97+/WRmuueaa9b5aMXnnnntuHH/88fG9730vrr766jj44IObf3MZ5IqSK0H66U9/Gp/5zGeakUGuUI961KOaczT/+Mc/jjgquOqqq5qRS8plmS9ceaQunxsZ2E984hPN/3vXu97VPF6OVKrJ5/uHPvShJjbvfve7m5P7v/nNbz4oeD//+c/jxz/+cRO0f/zjH03w8oUpfyZfUN7+9rc361O+cOR6li9Mb3jDG2LPPfdstp5y9JVBytFY94KWsUsZvCc96UnNVtinP/3pCS+B/Nl8Acvp2m677Zq/aarkb1oYESfnAGqqnzu5QhxyyCHx/e9/PzbZZJPma8uXL2/q323GdjMjXxnylejMM8+MJz/5yXHkkUfGXnvtFXvssUe8+c1vju233755RcsVqnsshuO6665rHjdHBC9+8YubUV6uXDmCy9FGtJtNuVKdeuqp8YxnPKM5mTSX5WmnndasWLmM+2Uccxnnz+UKEe3KtXTp0rj44oub/77sssua50juxsj/V82OO+4YF1xwQTM/czT2spe9LD784Q8/aC7svPPOTcwyhLku5SAgd/nk+pLzLj8uueSSZgCRL1g5j/fff//mBeeVr3xlM79zN9GXvvSl5jFe/epXr3vsfLHK5TeeUd1I8vSTNWvWNAOV3CSfSlmTEyPibRGxdCp+b26OZqByP9wVV1zRjBIuvPDCZoanzTffvJmR3ciu18tf/vLYe++946CDDoqbbropvvzlLzcr1F133dUstN13371ZMFP5ilFRrmjLli1rTh/IkV5uXv3lL39pXq1f//rXN3Pk8MMPb1bOHBnk6C/jlCteftx8880jjvAymhmz3ITKE1BTrhQ5EskXuRxR5IjmwAMPbEZ/eb5WRTkvc/7lC81o+1C7Tf2cnzkAyJFe777whQsXNiOs/Fp+3n0tl2PG8Itf/GITpX/+85/NcswRd0a2k+vnRPbd9cr1Mz9yPc/fN5WyDMum8hfmk/a8885r9uXkjE05xO5e8XNGdh8pZ3q/X/7yl81IIXec5j6N3NzJr9mMnRoZrNz0yTPiDz300ObFK6P0gx/8oNkHF+1O7dxEzShmwHJTtxuR5bLt3xzNTbBcAXMkkt+XL2i5sj7kIQ9p9lm9853vbDbHcgSS+/7y+yY7wpjNcndAjpAz+CeeeGKz++c973nPqH9Rrj8Zu9wCyn3knT/96U/NaC/n9e9///vmq7/73e9iyZIlzec5788666zYb7/94le/+lUTzW4kmY+Z/90bwInI5Zy7OTK2r3vd66Z0aSyYqpFdp3tVyH+7FSCf0N2T969//WtT/zxCG+2mbL8cSeRCygWenvrUpzZfY2rkkzVHdrnzOUdvOarOzdkcDeyyyy7NNOR+pYxWjsJyRJabSd1IIkcm/Zu0uZ8o98t2BytyJJ+7J/KgVa6oj3jEI5pdGBnW3DTLfXgjbQXMdbkf7SMf+UizDPJdCc9//vPHPME/53OGKTcjn/Oc5zSByf1/uc5ss802zQtUzvsMYL6I5JHfHFXnfvIMa+6OyE3oXEfz51OOKnO55+j9hhtumNByyPU5l21uSmdcc7/uVMr30g78WfOEJzyh+bfbAd0r99vlkbccGeQrxemnnx7Pfe5zm30OeTQpw5WbrjkSzAWVm7+jXTEh9zPkCpVH/Jh6uf8lR2C50o0lj+g9+tGPXrerIUeEuRsiN4U7uXsjv6fbMZ4rRAY045b/9r6gZTBzRcufH/TVNGaLXLfyQEPu086YjSZfdPI9qd18zYN6uc7kC1An98nmCDvPcsjvzeDlMuqOoGbc8mOfffZp/jsDl+txPs5DH/rQCZ2a1O27y1FervejTXu3Tv/hD38YxBJZN2qa8uABrM+wgmfvPlCG4AFlCB5QhuABZQgeUIbgAWUIHlCG4AFlCB5QhuABZQgeUIbgAWVMe/Be+9rXNtfQH0teFeWwww6b7kkFZrlpD97RRx8d733ve5v7FowkY5fX6zriiCOme1KBWW7ag5eX7s47L+VVW/uj18Uub1ryxCc+cdqmEZgbZsQ+vJGiJ3bAoOWlSpdP9WXeR9IbvbzsdN7sR+yAQcoR3hkzZY5m9DJ2edPf17zmNWIHDFQGL2///sm8jcB0z9rcjO1u45jX6h/tQAbAZGTw8vZRh0/3Zm23zy4/8r6zeUPmkQ5kAEzWjDho0Ru7vHtZ2nXXXUUPGKhpD95IseuIHjBI0x68U045ZcTYdbro5fcBbIi8L23vjw/kHrXuSwtsCPelBdhAggeUIXhAGYIHlCF4QBmCB5QheEAZggeUIXhAGYIHlLFgmH/otttu65kEzBhGeEAZggeUIXhAGYIHlCF4QBmCB5QheEAZggeUIXhAGYIHzHXLI+LkiFg41LeWAcwASyLibRGx2ggPqOINggdUsVTwgDIyeAvbHXq3WOzAXJYHLU5sd+gBzGk5wltmEQMVZPCWWtJABQ5aAGUIHlCG4AFlCB5QhuABZQgeUIbgAWUIHlCG4AFlCB5QhuABZQgeUIbgAWUIHlCG4AFlCB5QhuABZQgeUIbgAWUIHlCG4AFlCB5QhuABZQgeUIbgAWUIHlCG4AFlCB5QhuABZQgeUIbgAWUIHlCG4AFlCB5QhuABZQgeUIbgAVUsFzygii8tsKiBOW5FRJwREe8RPGCuW9r9fTZpgTIyeMstbqCC+e22LcCcl/vwjomIeRGxLCKWWOTAXJUjvHsi4vDeHXsAc5GDFkAZggeUIXhAGYIHlCF4QBmCB5QheEAZggeUIXhAGYIHlJHBWxgRJ0fELRY7MJflxQNOjIi3WcrAXDe/vUoKQInguUoKUIKDFkAZggeUIXhAGYIHlCF4QBmCB5QheEAZggeUIXhAGYIHlCF4QBmCB5QheEAZggeUIXhAGYIHlCF4QBmCB5QheEAZggeUIXhAGYIHlCF4QBmCB5QheEAZggeUIXhAGYIHlCF4QBmCB5QheEAZggeUIXhAGYIHlCF4QBmCB5QheEAZggeUIXhAGYIHlCF4QBkZvOUWN1BBBu8MSxqoYEFEHBMR8yJiWUQssdSBuSpHePdExOERsdRSBuYyBy2AMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKEPwgDIEDyhD8IAyBA8oQ/CAMgQPKGOowbv11ls9k4AJGWY3hhq8888/f5gPD8xBZ5999tD+qAXDeNCtt946brvttjjhhBNi3rx5sd9++zVfAxhNNiMHSSeddNK6jgzavNWrV/c+5NpBPP7xxx8fZ555pgULTNphhx0WRx555CBm4Lzuk6GM8I466qhYu3ZtXHDBBXH77bcP41cAc9RWW20V++67b7z1rW8d+B84lBEewAyyboTntBSgDMEDyhA8oAzBA8oQPKAMwQPKEDygDMEDyhA8oAzBA8oQPKCMoVw8ADpr1qyJu+++O+65556477774v7772++lheXSHn5sPnz58dGG20UCxYsiIULF8Ymm2zSfA0GzcUDGLgM2p133hn53Lr33nsn9fAbb7xxbLbZZrH55puLHxtq3cUDBI+BydHbqlWrmo/eEVw3assRXH5kwPLrKb8vA5mjv/zoRoO9P5/R23LLLZtRIEyC4DFYd9xxR6xcuXJdqDJwGapNN910XdzGKx/jrrvuakaJGcBow7do0aLYYostJvx4lCd4DEaOylasWLFu0zUDl2HKTdJByMfNkGYAo93UXbJkSTNShHESPDZcRihjlyOy3NxcvHhxM7Ibhhzp5d2scrM5R3gZvYwrjIPgsWFyc7O7nV4eXMjYDXtTM8Oav7N7zubvzM1mWA/BY/LyoETeYSrl5mt+TKXcxM2PaO9slfv1YAwu8c7k5GZsF7uMzVTHLtrIdrfwy2np9u/B+gge49YdoIg2OtM5ssrf3cU2pymnDdZH8BiX3H/WHaDIfXbTMbLrl9OQ09I7bTAWwWNccr9dniKSR2OHcUf4ycppyWnKactphLEIHuuVp4J0BwnyyOhMeqtXTktOU7QHM3JaYdTniznD+uS7KHJzMc97G9Z5dhsipymnLacxpxVGI3iMqbsQQLT7zGaqbtpyWnOaYSSCx5jyPM0cOeUoalBvFxuGnLacxpzWvnNLYR3BY0zd6G42vKOhm8ZumqGf4DGq3DTMo5/5lrHZ8L7V7sosOc0OXjASwWNU3aWZ8np2s+GSTN2191JeUw/6CR6j6qIxE4/MjqabVsFjJILHqLq3a82ma8910+qtZoykP3heFlmn2w82G4NnHx4j6Q/eSnOJTheN2XQTnW5aBY/WA85EFzxG1Xsjndmi9+ZAkFc0650Jgsec5EY/tJb3zoj+4C03l+jMxtHSbByVMlR/733w/uBda97T6e4DO5vem9pNq5t307qmd0b0PyuuNJfodMGbTad4dNPqpt20/tQ7IwSPUc3Gc9pm47mDDNVVvQ8ueIyqe5tW9xaz2aD37XCwvhFe1nCFuUT0vU1rNhy4yGns3lImeLQtG3OEl2dr/sScItod/3mduQzJbLgVYk5jTmtOs314RMRP26atM9KhrB+aU3Rm0zXmumnMO5lBRPygfyYIHmPKeOQ5bblvLK8zN1PltOU05rTOhouVMiV+1P9LRgreHyPiBsuDaDdru4B0dy6bibppy2l1Dh5twy7vnxEjPTNy7/Q55hidLbfcshk55T6ymXjENqcppy2nMacV2oY96EjbaC+FZ5hjdPIAQHdXsFtvvXVGvfMiD1LkNEV75zIHK2idOdKMGC14v4+IX5tzdLbYYovm6Gdedum2226bMfMlY5fTlNOW0whtu3430owYa2fHp805Orm5uGTJkubfvA3iTNifl9OQ09I7bTBWu+aNcQ/PPHPz+ojY1hykk/vKli///xfV2XrrradtVLVq1ap1I82lS5fOiruqMSX+KyK2G+3q7WON8PIHPmoZ0SvDkqFLGZzpGOnl7+xil9MidvT42Fi3qhhrhJfyDM6rI+Lh5ii98iTf7mBBnqu3ePHioW9Sdgcouuds/k7n3NHjpojYISJGjdr6TljKHzzWHKVfhiY3Jbt9ejfffPNQT1nJx87f0e2zy98tdvQ5dqzYxThGeNFG8eKI2M3cpV9ejmnFihXr3oWRm5d5ekgeNR2EfNzchO3ey5uPmwcoXP6JPpdGxFPyGrBjzZjxBC/tHhG/ylOyzGX65aZmHkTIMHVXVckrreQILAM40U3d7mIFudncjRq7k4q7k6ChR14gYM+IuGR9M2W8wUsnRsT/NJcZTZ4Pl+HLj957S+SlmjKAOSrLj3zrV+/9MvJE5hwp5kcGrvdyVN17YzN0TipmFB+JiGPGM3MmErw8TeXn7bARRpUBy9FZPrcme8GB3HTNgyHeG8t65EnGzxjryGyviQQv2vNbfpsHyCwFxiPj143acgSXo8D8Wu8ILoOWo7cc/XWjQZFjHPI0gV0j4rrxzqyJBi/tHxHfzJ+1RIBpkq+Yr4iIcyfy6yfzMnpeRJxgKQPT6ISJxi4mOcKLdnSXV1R5rSUOTLGvRsSykS7/tD6T3VGSv+iQdrQHMFXOa9szqbtKbcie4Tz35SDRA6bIeW1z7p/sr9vQQ2F5KPjAiDjdEgeG6Iy2NeM6/WQ0gzj2n7d6PzQijpvsMBNgDMe1m7H3behMmuxBi9HsFxH/23l6wADkeXb/HhHnD2pmDvrszvPbEwHX+542gDFc0rZkYLGLIQQv2rOen9a+v22Dh6BAKfe17XjaRN5BMV6D3qTtl1dZ+UJEPNlzFliPfNvqfxvmFuKw37B4SRu9/4iIG4f8u4DZ6a9tI3Yf9u6wYY/wei1sj+b+r4j416n6pcCMlZusx0fEqRt6usl4TWXwOgvakwffFBF7TfUvB6bdf0bEZyPirKnezz8dweu1fXt+zWvaz4G56ZqI+FpEnNZ+Pi2mO3idvBjBLhGxT0TsHRF7RMSimTBhwKTk/TsviogfRsSFEXHZTHhjwkwJXr+8lveOEfHEiNipvfBofvxLRGzT3j5yeu4ADaRV7R3CbomIf7Y37c+PyyPi/0bEFRvyntehiIj/B2SDpEYkcSX3AAAAAElFTkSuQmCC");
}

.screen-ul {
  position: relative;
  top: -25%;
  left: -25px;
  padding-inline-start: 0;
}

.screen-ul li {
  width: 94px;
  height: 40px;
  line-height: 40px;
  font-size: 13px;
  text-align: left;
  background-color: #eeeeef;
  border-radius: 20px;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  margin-bottom: 7px;
  text-indent: 10px;
  color: #000;
  cursor: pointer;
  position: relative;
}

.screen-ul li.active {
  background-color: #ecf7ff !important;
  color: #262de2;
  cursor: auto;
  outline: none;
}

.preview-modal img {
  position: relative;
  top: -40%;
  cursor: pointer;
}

.replace-confirm {
  float: right;
  margin-right: 2px;
  margin-bottom: 10px;
  cursor: pointer;
  padding: 2px 8px;
  border: none;
  border-radius: 4px;
  background: #2a374b;
  color: #fff;
}

.vd-bottom-editor {
  float: right;
  margin-right: 2px;
  margin-bottom: 10px;
  cursor: pointer;
  padding: 2px 8px;
  border: none;
  border-radius: 4px;
  background: #2a374b;
  color: #fff;
}

.colorpicker {
  background-color: #2a374b;
  width: 270px;
  padding: 8px 16px;
  border-radius: 5px;
  color: grey;
  z-index: 1400;
  position: absolute;
  border: white 1px solid;
}

.clearfix {
  content: " ";
  display: table;
}
</style>
